














































import { Controllers, IsBadRequestResult, IsServerErrorResult, OutOfOffice, ProblemResult, UserPatch } from "@infoland/iprova-api";
import storeHelper from "@/store/store-helper";
import Utils from "@/utils";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import PasswordStrengthInput from "../settings/PasswordStrengthInput.vue";
import { SnackBarTimeout } from "@/enums";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ChangePasswordContent",
    props: {},
    components: { PasswordStrengthInput },
    data: () => {
        return {
            currentPassword: "",
            newPassword: "",
            repeatPassword: "",
            patchError: null as string
        };
    },
    computed: {
        currentPasswordRules(): (boolean | string)[] {
            let currentPasswordMessage = [!!this.currentPassword || this.$t("settings.changePassword.isRequired").toString()];
            if (this.patchError == "InvalidOldPassword") {
                currentPasswordMessage.push(this.$t("settings.changePassword.currentPasswordInvalid").toString());
            }
            return currentPasswordMessage;
        },
        newPasswordRules(): (boolean | string)[] {
            let newPasswordMessage = [];
            if (this.patchError == "NewPasswordSameAsOldPassword") {
                newPasswordMessage.push(this.$t("settings.changePassword.currentAndNewPasswordSame").toString());
            }
            return newPasswordMessage;
        },
        repeatNewPasswordRules(): (boolean | string)[] {
            return [
                !!this.repeatPassword || this.$t("settings.changePassword.isRequired").toString(),
                this.repeatPassword == this.newPassword || this.$t("settings.changePassword.passwordMatch").toString()
            ];
        }
    },
    methods: {
        clearInvalidOldPasswordError() {
            if (this.patchError == "InvalidOldPassword") {
                this.patchError = null;
            }
        },
        clearNewSameAsOldError() {
            if ((this.patchError = "NewPasswordSameAsOldPassword")) {
                this.patchError = null;
            }
        },
        async changePasswordAsync(): Promise<boolean> {
            this.patchError = null;
            let form = this.$refs.form as Vue & { validate: () => boolean };
            if (form.validate() == false) return false;
            const loggedOnUser = storeHelper.userStore.loggedOnUser;
            const result = await Controllers.GenericController.patchAsync<any, void | ProblemResult<string>>(
                `/users/${loggedOnUser.user_id}`,
                {
                    old_password: this.currentPassword,
                    new_password: this.newPassword
                },
                true
            );

            if (IsBadRequestResult(result)) {
                this.patchError = result.extrainfo;
                if (form.validate() == false) return false;
                if (result.extrainfo != "InvalidOldPassword" && result.extrainfo != "NewPasswordSameAsOldPassword") {
                    storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                }
                return false;
            } else if (IsServerErrorResult(result)) {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
                return false;
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("settings.changePassword.passwordChanged").toString(), false, SnackBarTimeout.short);
                this.$emit("close-change-password");
                return true;
            }
        }
    },
    created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.changePasswordAsync });
    }
});
